import agent, { prepareHeaders } from 'api/agent';
import {
    MapTableDTO,
    MapTableModel,
    QRCodeDTO,
    TablesMapDTO,
    TablesMapModel,
} from 'store/tableMapsStore/mappers';

export interface DineInQrCode {
    name: string;
    isUsed: boolean;
}

const BASE = 'restaurant/tables-maps';

export const TableMaps = {
    getDineInQrCodes: (): Promise<DineInQrCode[]> =>
        (agent.requests.get('restaurant/qrcodes') as Promise<QRCodeDTO[]>).then((codes) =>
            codes
                .filter((c) => c.service === 'DineIn')
                .map((c) => ({ name: c.name, isUsed: c.isUsed }))
        ),

    getTablesMaps: (): Promise<TablesMapDTO[]> => agent.requests.get(BASE),

    getTablesMap: (id: string): Promise<TablesMapDTO> => agent.requests.get(`${BASE}/${id}`),

    createTablesMap: (model: TablesMapModel): Promise<TablesMapDTO> =>
        agent.requests.post(BASE, model),

    updateTablesMap: (id: string, model: TablesMapModel): Promise<TablesMapDTO> =>
        agent.requests.put(`${BASE}/${id}`, model, prepareHeaders()),

    deleteTablesMap: (id: string): Promise<void> => agent.requests.delete(`${BASE}/${id}`),

    copyTablesMap: (id: string): Promise<TablesMapDTO> => agent.requests.post(`${BASE}/${id}/copy`),

    createMapTable: (mapId: string, model: MapTableModel): Promise<MapTableDTO> =>
        agent.requests.post(`${BASE}/${mapId}/tables`, model),

    updateMapTable: (mapId: string, tableId: string, model: MapTableModel): Promise<MapTableDTO> =>
        agent.requests.put(`${BASE}/${mapId}/tables/${tableId}`, model, prepareHeaders()),

    deleteMapTable: (mapId: string, tableId: string): Promise<void> =>
        agent.requests.delete(`${BASE}/${mapId}/tables/${tableId}`),
};
